import { createContext, useContext } from 'react'

/** Какие складские отчёты выданы человеку: раздел работает без финансового контекста. */
export const StockAccessContext = createContext<{ current: boolean; turnover: boolean; margin: boolean }>({
  current: false,
  turnover: false,
  margin: false,
})

export function useFinanceLessAccess() {
  return useContext(StockAccessContext)
}
